export type Env = null | 'prod' | 'deve' | 'dev' | 'qa' | 'prelive';

export const getEnv = (baseUrl?: string): Env => {
  if (!baseUrl) {
    return null;
  }
  const url = new URL(baseUrl);
  const firstHostPart = url?.hostname?.split('.')[0];

  switch (firstHostPart) {
    case 'solutions':
    case 'www':
      return 'prod';
    case 'wwwdeve':
      return 'deve';
    case 'wwwtest':
      return 'qa';
    case 'localhost':
      return 'dev';
    case 'deve':
    case 'qa':
    case 'prelive':
      return firstHostPart;
    default:
      return null;
  }
};

export default { getEnv };
